import { actionCreator } from '@ardoq/rxbeach';

export const fileExportChanged = actionCreator<{ isExporting: boolean }>(
  '[fileExports] file export changed'
);
